var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M9 3v1H4v2h1v13a2 2 0 002 2h10a2 2 0 002-2V6h1V4h-5V3H9M7 6h10v13H7V6m2 2v9h2V8H9m4 0v9h2V8h-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }